import Swiper from "swiper";
import { isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady } from "../utils/dom";
import "./styles/_golf-tabs.scss";
import 'swiper/swiper-bundle.css';

let userComeAcrossWithSection = false; 

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

const state = {
  elements: {},
};

function cacheState() {
  const sections = Array.from(document.querySelectorAll(".golf-tabs"));
  state.components = sections.reduce((acc, curr) => {
    const currentComponent = {
      swiperEl: curr.querySelector('.swiper.golf-tabs__slider'),
      totalSlides: Array.from(curr.querySelectorAll('.swiper-slide.golf-tabs__slide')).length,
      banners: Array.from(curr.querySelectorAll(".golf-tabs__tab")),
    };
    return [...acc, currentComponent];
  }, []);
}

function initSwipers() {
  state.components.forEach((component) => {
    component.swiper = new Swiper(component.swiperEl, {
      slidesPerView: 2.5,
      spaceBetween: 2.5,
      loop: true,
      slideToClickedSlide: true,
      breakpoints: {
        600: {
          slidesPerView: 4,
        }
      },

      on: {
        slideChange(swiper) {
          const sliderIndex = swiper.realIndex;
          component.banners.forEach((banner) => {
            banner.classList.toggle("active", sliderIndex === +banner.dataset.index);
          });
          document.dispatchEvent(new CustomEvent('swiper:slide:changed'));
        }
      }
    });
  });
}

function attachEventListeners() {
  // Attach the debounced function to the resize event
  const debouncedSetVideoBackground = debounce(setVideoBackground, 200);
  window.addEventListener("resize", debouncedSetVideoBackground);
}

function initVideo() {
  state.components?.forEach((component) => {
    const { banners } = component;

    banners?.forEach((banner) => {
      const videoEl = banner.querySelector("video");
      if (!videoEl) return;

      let wasPlaying = true;
      let wasMuted = true;
      const playPauseBtn = banner.querySelector('[data-type="video"]');
      const muteUnmuteBtn = banner.querySelector('[data-type="audio"]');

      playPauseBtn.addEventListener("click", () => {
        if (playPauseBtn.dataset.state === "playing") {
          videoEl.pause();
          playPauseBtn.dataset.state = "paused";
        } else {
          videoEl.play();
          playPauseBtn.dataset.state = "playing";
        }
      });

      muteUnmuteBtn.addEventListener("click", () => {
        if (muteUnmuteBtn.dataset.state === "muted") {
          videoEl.muted = false;
          muteUnmuteBtn.dataset.state = "unmuted";
        } else {
          videoEl.muted = true;
          muteUnmuteBtn.dataset.state = "muted";
        }
      });

      document.addEventListener('swiper:slide:changed', () => {
        if (playPauseBtn.dataset.state === "playing") {
          videoEl.pause();
          playPauseBtn.dataset.state = "paused";
        } else if (videoEl.closest(".golf-tabs__tab").classList.contains("active")) {
          videoEl.play();
          playPauseBtn.dataset.state = "playing";
        }
      });

      const observer = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) {
          if (userComeAcrossWithSection) {
            wasPlaying = !videoEl.paused;
          }
          wasMuted = videoEl.muted;

          videoEl.pause();
          playPauseBtn.dataset.state = "paused";
          return;
        }

        videoEl.muted = wasMuted;
        userComeAcrossWithSection = true;
        if (!wasPlaying) return;

        videoEl.play();
        playPauseBtn.dataset.state = "playing";
      }, options);
      observer.observe(videoEl);
    });
  });
}

function setVideoBackground() {
  const isMobile = window.matchMedia('(max-width: 600px)').matches;
  state.components.forEach((component) => {
    const { banners } = component;
    banners.forEach((banner) => {
      const video = banner.querySelector("video");
      if (!video) return;

      const currentSrc = video.src;
      const newSrc = isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (currentSrc === newSrc) return;
      video.src = newSrc;
    });
  });
}

function init() {
  const isLoadedBefore = isScriptFullyLoaded("golf-tabs");
  if (isLoadedBefore) return;
  markScriptFullyLoaded("golf-tabs");

  cacheState();
  initSwipers();
  setVideoBackground();
  initVideo();
  attachEventListeners();
}

onDocumentReady(init);
